import { api } from '../api';

export enum AdvertSizes {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export enum AdvertTypes {
  BANNER = 'BANNER',
  BLOCK = 'BLOCK',
}

export interface Advert {
  id: number;
  type: AdvertTypes;
  title: string;
  image: string;
  link: string;
  size: AdvertSizes;
  description?: string | null;
  advertiser?: string | null;
  buttonText?: string | null;
  weight?: number | null;
}

export const getAdverts = ({
  size,
  limit,
}: { size?: AdvertSizes; limit?: number } = {}) => {
  const queryParams = new URLSearchParams();

  if (size) queryParams.append('size', size);
  if (limit !== undefined) queryParams.append('limit', limit.toString());

  return api
    .get<Advert[]>(`/v1/promo/avd${queryParams.size ? `?${queryParams.toString()}` : ''}`)
    .then((res) => res.data);
};

/** Промо-баннеры листинга: /v1/promo/listing */
export const getListingPromos = () => {
  return api.get<Advert[]>('/v1/promo/listing').then((res) => res.data);
};

export const clickAdvert = (advertId: number) => {
  return api.put<void>(`/v1/promo/${advertId}/click`).then((res) => res.data);
};

export const showAdvert = (advertId: number) => {
  return api.put<void>(`/v1/promo/${advertId}/show`).then((res) => res.data);
};
